(() => {
  const money = (cents, currency) =>
    new Intl.NumberFormat(undefined, { style: "currency", currency: currency || "USD" })
      .format((Number(cents) || 0) / 100);

  const tierFor = quantity =>
    quantity >= 288 ? 30 :
    quantity >= 144 ? 26 :
    quantity >= 72 ? 22 :
    quantity >= 48 ? 18 :
    quantity >= 36 ? 10 : 0;

  const normalizedSku = value => String(value || "").trim().toUpperCase();

  document.querySelectorAll("[data-apparel-builder]").forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = "1";

    const currency = root.dataset.currency || "USD";
    const form = root.querySelector("form");
    const variants = JSON.parse(root.querySelector("[data-product-json]").textContent);
    const addonProducts = JSON.parse(root.querySelector("[data-addon-products-json]").textContent);
    const addonConfig = JSON.parse(root.querySelector("[data-addon-config-json]").textContent);

    const directEmbroideryVariants = Array.isArray(addonProducts.embroideryDecoration)
      ? addonProducts.embroideryDecoration
      : [];

    const qInput = root.querySelector("input[data-qty]");
    const hiddenQty = root.querySelector("[data-form-qty]");
    const fileBucket = root.querySelector("[data-file-bucket]");
    const fileList = root.querySelector("[data-file-list]");
    const message = root.querySelector("[data-message]");
    const variantSelect = root.querySelector("[data-variant-select]");
    const selectedColorName = root.querySelector("[data-selected-color-name]");
    const startingPrice = root.querySelector("[data-starting-price]");
    const mainImage = root.querySelector("[data-main-image]");
    const sizeBreakdown = root.querySelector("[data-size-breakdown]");
    const sizeInputs = [...root.querySelectorAll("[data-size-qty]")];
    const sizeTotalEl = root.querySelector("[data-size-total]");
    const sizeOrderTotalEl = root.querySelector("[data-size-order-total]");
    const sizeStatus = root.querySelector("[data-size-status]");
    const embroiderySizeGroup = root.querySelector('[data-choice-group="embroidery-size"]');
    const embroiderySizeInput = root.querySelector("[data-embroidery-size-inches]");
    let files = [];

    const decoration = () =>
      root.querySelector("[data-decoration].is-selected")?.dataset.decoration || "DTF";

    const choiceValue = group =>
      root.querySelector(`[data-choice-group="${group}"] [data-choice].is-selected`)?.dataset.choiceValue || "";

    const allAddonVariants = Object.values(addonProducts).flat().filter(Boolean);
    const addonBySku = new Map(
      allAddonVariants
        .filter(variant => normalizedSku(variant.sku))
        .map(variant => [normalizedSku(variant.sku), variant])
    );

    const defs = {};
    const setPriceLabels = (key, text) => {
      root.querySelectorAll(`[data-addon-price-label="${key}"]`)
        .forEach(label => label.textContent = text);
    };

    Object.entries(addonConfig).forEach(([key, config]) => {
      const variant = addonBySku.get(normalizedSku(config.sku));
      const checkboxes = [...root.querySelectorAll(`[data-addon-check="${key}"]`)];

      if (!variant) {
        defs[key] = null;
        setPriceLabels(key, "Not connected");
        checkboxes.forEach(input => {
          input.disabled = true;
          input.checked = false;
        });
        root.querySelectorAll(`[data-linked-addon="${key}"]`).forEach(button => {
          button.disabled = true;
          button.classList.remove("is-selected");
        });
        return;
      }

      defs[key] = {
        id: Number(variant.id),
        price: Number(variant.price || 0),
        charge: config.charge,
        available: variant.available !== false,
        title: variant.title,
        sku: variant.sku
      };

      const suffix = config.charge === "one_time" ? " once" : "/pc";
      setPriceLabels(key, `+${money(variant.price, currency)}${suffix}`);

      if (variant.available === false) {
        checkboxes.forEach(input => {
          input.disabled = true;
          input.checked = false;
        });
        root.querySelectorAll(`[data-linked-addon="${key}"]`).forEach(button => {
          button.disabled = true;
          button.classList.remove("is-selected");
        });
        setPriceLabels(key, `+${money(variant.price, currency)}${suffix} — unavailable`);
      }
    });

    const directEmbroideryVariant =
      directEmbroideryVariants.find(variant => variant.available !== false) ||
      directEmbroideryVariants[0];

    if (directEmbroideryVariant) {
      defs.embroidery_base = {
        id: Number(directEmbroideryVariant.id),
        price: Number(directEmbroideryVariant.price || 0),
        charge: "per_piece",
        available: directEmbroideryVariant.available !== false,
        title: directEmbroideryVariant.title || "Embroidery Decoration",
        sku: directEmbroideryVariant.sku || ""
      };

      updatePriceLabels(
        "embroidery_base",
        `+${money(directEmbroideryVariant.price, currency)}/pc`
      );
    }

    const chosenVariant = () =>
      variants.find(v => v.id === Number(variantSelect.value)) || variants[0];

    const qty = () => Math.max(24, Number(qInput.value) || 24);

    const selectedKeys = () => {
      const keys = [...root.querySelectorAll("[data-addon-check]:checked")]
        .filter(input => !input.closest("[hidden]"))
        .map(input => input.dataset.addonCheck);

      if (decoration() === "Embroidery") {
        keys.push("embroidery_base");
      }

      if (decoration() === "DTF") {
        const linked = root.querySelector(
          '[data-choice-group="dtf-placement"] [data-choice].is-selected'
        )?.dataset.linkedAddon;
        if (linked) keys.push(linked);
      }

      return [...new Set(keys)];
    };

    function colorIndex() {
      const button = root.querySelector("[data-color-value]");
      return button ? Number(button.dataset.colorIndex || 0) : -1;
    }

    function variantForColor(color) {
      const index = colorIndex();
      const current = chosenVariant();
      if (index < 0) return null;

      return variants.find(v =>
        v.available !== false &&
        v.options[index] === color &&
        v.options.every((value, i) =>
          i === index || !current?.options?.[i] || value === current.options[i]
        )
      )
        || variants.find(v => v.available !== false && v.options[index] === color)
        || variants.find(v => v.options[index] === color);
    }

    function showColorMedia(color, variant) {
      const thumbs = [...root.querySelectorAll("[data-media-color]")];
      const needle = String(color || "").toLowerCase();
      let shown = 0;

      thumbs.forEach(button => {
        const matches =
          !needle ||
          String(button.dataset.mediaColor || "").toLowerCase().includes(needle);
        button.hidden = !matches;
        if (matches) shown += 1;
      });

      if (!shown) thumbs.forEach(button => button.hidden = false);

      if (variant?.featured_image?.src && mainImage) {
        mainImage.src = variant.featured_image.src;
        mainImage.alt = variant.featured_image.alt || variant.title;
      }
    }

    function selectVariant(variant) {
      if (!variant) return;
      variantSelect.value = String(variant.id);

      const index = colorIndex();
      const color = index >= 0 ? variant.options[index] : variant.title;
      if (selectedColorName) selectedColorName.textContent = color;

      root.querySelectorAll("[data-color-value], [data-direct-variant-id]").forEach(button => {
        const active = button.dataset.directVariantId
          ? Number(button.dataset.directVariantId) === Number(variant.id)
          : button.dataset.colorValue === color;

        button.classList.toggle("is-selected", active);
        button.setAttribute("aria-pressed", active ? "true" : "false");
      });

      showColorMedia(color, variant);
      calc();
    }

    root.querySelectorAll("[data-color-value]").forEach(button => {
      button.addEventListener("click", () =>
        selectVariant(variantForColor(button.dataset.colorValue))
      );
    });

    root.querySelectorAll("[data-direct-variant-id]").forEach(button => {
      button.addEventListener("click", () =>
        selectVariant(
          variants.find(v => Number(v.id) === Number(button.dataset.directVariantId))
        )
      );
    });

    root.querySelectorAll("[data-media-src]").forEach(button => {
      button.addEventListener("click", () => {
        if (mainImage) mainImage.src = button.dataset.mediaSrc;
        root.querySelectorAll("[data-media-src]").forEach(item =>
          item.classList.remove("is-active")
        );
        button.classList.add("is-active");
      });
    });

    function refreshConditionalRows() {
      const current = decoration();

      root.querySelectorAll("[data-artwork-row]").forEach(row => {
        const visible = row.dataset.artworkRow === current;
        row.hidden = !visible;
        if (!visible) row.querySelectorAll("[data-addon-check]").forEach(i => i.checked = false);
      });

      root.querySelectorAll("[data-extra-decoration]").forEach(row => {
        const showFor = row.dataset.extraDecoration || "all";
        const visible = showFor === "all" || showFor === current;
        row.hidden = !visible;
        if (!visible) row.querySelectorAll("[data-addon-check]").forEach(i => i.checked = false);
      });
    }

    function sizeBreakdownData() {
      return sizeInputs
        .map(input => ({
          size: input.dataset.sizeName || "",
          qty: Math.max(0, Number(input.value) || 0)
        }))
        .filter(item => item.size);
    }

    function sizeBreakdownTotal() {
      return sizeBreakdownData().reduce((sum, item) => sum + item.qty, 0);
    }

    function sizeBreakdownText() {
      const entries = sizeBreakdownData()
        .filter(item => item.qty > 0)
        .map(item => `${item.size}: ${item.qty}`);
      return entries.length ? entries.join(" | ") : "Not provided";
    }

    function updateSizeBreakdown() {
      if (!sizeBreakdown) return true;

      const orderQty = qty();
      const total = sizeBreakdownTotal();
      const matches = total === orderQty;
      const requireMatch = sizeBreakdown.dataset.requireMatch === "true";

      if (sizeTotalEl) sizeTotalEl.textContent = total;
      if (sizeOrderTotalEl) sizeOrderTotalEl.textContent = orderQty;

      sizeBreakdown.classList.toggle("is-match", matches);
      sizeBreakdown.classList.toggle("is-mismatch", !matches && total > 0);

      if (sizeStatus) {
        if (matches) {
          sizeStatus.textContent =
            sizeBreakdown.dataset.matchText ||
            "Size breakdown matches the order quantity.";
        } else if (requireMatch) {
          sizeStatus.textContent =
            sizeBreakdown.dataset.mismatchBlockedText ||
            "Size quantities must equal the order quantity before adding to cart.";
        } else {
          sizeStatus.textContent =
            sizeBreakdown.dataset.mismatchAllowedText ||
            "Size quantities do not have to equal the order quantity.";
        }
      }

      return !requireMatch || matches;
    }

    function calc() {
      const quantity = qty();
      qInput.value = quantity;
      hiddenQty.value = quantity;

      const discount = tierFor(quantity);
      const base = Number(chosenVariant().price || 0);
      let perPiece = 0;
      let oneTime = 0;

      selectedKeys().forEach(key => {
        const def = defs[key];
        if (!def || !def.available) return;
        if (def.charge === "one_time") oneTime += def.price;
        else perPiece += def.price;
      });

      const discountedUnit = Math.round((base + perPiece) * (1 - discount / 100));
      const total = discountedUnit * quantity + oneTime;

      root.querySelector("[data-sum-base]").textContent = `${money(base, currency)}/pc`;
      root.querySelector("[data-sum-addons]").textContent =
        `${money(perPiece, currency)}/pc + ${money(oneTime, currency)} once`;
      root.querySelector("[data-sum-discount]").textContent = `${discount}%`;
      root.querySelector("[data-sum-unit]").textContent = money(discountedUnit, currency);
      root.querySelector("[data-sum-qty]").textContent = `${quantity} pcs`;
      root.querySelector("[data-sum-total]").textContent = money(total, currency);

      if (startingPrice && variants.length) {
        const lowest = Math.min(...variants.map(v => Number(v.price || 0)));
        startingPrice.innerHTML = `${money(lowest, currency)}<small>/pc</small>`;
      }

      root.querySelectorAll("[data-tier]").forEach(button => {
        button.classList.toggle(
          "is-selected",
          Number(button.dataset.discount) === discount
        );
      });

      updateSizeBreakdown();
    }

    root.querySelectorAll("[data-tier]").forEach(button => {
      button.addEventListener("click", () => {
        qInput.value = button.dataset.qty;
        calc();
      });
    });

    root.querySelector("[data-minus]")?.addEventListener("click", () => {
      qInput.value = Math.max(24, qty() - 1);
      calc();
    });

    root.querySelector("[data-plus]")?.addEventListener("click", () => {
      qInput.value = qty() + 1;
      calc();
    });

    qInput?.addEventListener("input", calc);

    function syncEmbroiderySizeFromInches() {
      if (!embroiderySizeInput || !embroiderySizeGroup) return;

      const inches = Number(embroiderySizeInput.value);
      if (!Number.isFinite(inches) || inches <= 0) return;

      const size1Max = Number(embroiderySizeGroup.dataset.size1Max || 4);
      const size2Max = Number(embroiderySizeGroup.dataset.size2Max || 6);
      const buttons = [...embroiderySizeGroup.querySelectorAll("[data-choice]")];

      let selectedIndex = 2;
      if (inches <= size1Max) selectedIndex = 0;
      else if (inches <= size2Max) selectedIndex = 1;

      buttons.forEach((button, index) => {
        button.classList.toggle("is-selected", index === selectedIndex);
      });

      calc();
    }

    embroiderySizeInput?.addEventListener("input", syncEmbroiderySizeFromInches);
    embroiderySizeInput?.addEventListener("change", syncEmbroiderySizeFromInches);

    root.querySelectorAll("[data-choice-group]").forEach(group => {
      group.querySelectorAll("[data-choice]").forEach(button => {
        button.addEventListener("click", () => {
          group.querySelectorAll("[data-choice]").forEach(item =>
            item.classList.remove("is-selected")
          );
          button.classList.add("is-selected");
          calc();
        });
      });
    });

    root.querySelectorAll("[data-decoration]").forEach(button => {
      button.addEventListener("click", () => {
        root.querySelectorAll("[data-decoration]").forEach(item =>
          item.classList.remove("is-selected")
        );
        button.classList.add("is-selected");

        root.querySelectorAll("[data-decoration-panel]").forEach(panel => {
          panel.hidden = panel.dataset.decorationPanel !== button.dataset.decoration;
        });

        root.querySelectorAll("[data-decoration-panel] [data-addon-check]").forEach(input => {
          if (input.closest("[data-decoration-panel]")?.hidden) {
            input.checked = false;
            const reveal = root.querySelector(
              `[data-upload-reveal="${input.dataset.addonCheck}"]`
            );
            if (reveal) reveal.hidden = true;
          }
        });

        refreshConditionalRows();
        calc();
      });
    });

    root.querySelectorAll("[data-addon-check]").forEach(input => {
      input.addEventListener("change", () => {
        const reveal = root.querySelector(
          `[data-upload-reveal="${input.dataset.addonCheck}"]`
        );
        if (reveal) reveal.hidden = !input.checked;
        calc();
      });
    });

    sizeInputs.forEach(input => {
      input.addEventListener("input", () => {
        input.value = Math.max(0, Number(input.value) || 0);
        updateSizeBreakdown();
      });
    });

    root.querySelectorAll("[data-size-minus]").forEach(button => {
      button.addEventListener("click", () => {
        const input = button.parentElement?.querySelector("[data-size-qty]");
        if (!input) return;
        input.value = Math.max(0, (Number(input.value) || 0) - 1);
        updateSizeBreakdown();
      });
    });

    root.querySelectorAll("[data-size-plus]").forEach(button => {
      button.addEventListener("click", () => {
        const input = button.parentElement?.querySelector("[data-size-qty]");
        if (!input) return;
        input.value = (Number(input.value) || 0) + 1;
        updateSizeBreakdown();
      });
    });

    root.querySelector("[data-file-picker]")?.addEventListener("change", event => {
      [...event.target.files].forEach(file => files.push(file));
      renderFiles();
      event.target.value = "";
    });

    function renderFiles() {
      fileBucket.innerHTML = "";
      fileList.innerHTML = "";

      files.forEach((file, index) => {
        const input = document.createElement("input");
        input.type = "file";
        input.hidden = true;
        input.name = `properties[Artwork ${index + 1}]`;

        const transfer = new DataTransfer();
        transfer.items.add(file);
        input.files = transfer.files;
        fileBucket.append(input);

        const row = document.createElement("div");
        row.className = "cpb__file";
        row.innerHTML = `<span>${file.name}</span><button type="button" aria-label="Remove ${file.name}">×</button>`;
        row.querySelector("button").addEventListener("click", () => {
          files.splice(index, 1);
          renderFiles();
        });
        fileList.append(row);
      });
    }

    form.addEventListener("submit", async event => {
      event.preventDefault();
      message.hidden = false;

      if (!updateSizeBreakdown()) {
        message.textContent =
          sizeBreakdown?.dataset.mismatchBlockedText ||
          "Size quantities must equal the order quantity before adding to cart.";
        sizeBreakdown?.scrollIntoView({ behavior: "smooth", block: "center" });
        return;
      }

      message.textContent = "Adding configuration…";

      const quantity = qty();
      const mainVariant = chosenVariant();
      const configurationId =
        `CFG-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
      const currentDecoration = decoration();

      const commonProperties = {
        "_Configuration ID": configurationId,
        "_Builder Category": "apparel",
        "Decoration": currentDecoration,
        "Placement":
          currentDecoration === "DTF"
            ? choiceValue("dtf-placement")
            : choiceValue("embroidery-placement"),
        "Size Breakdown": sizeBreakdown ? sizeBreakdownText() : "",
        "Size Total": sizeBreakdown ? `${sizeBreakdownTotal()} / ${quantity}` : ""
      };

      if (currentDecoration === "Embroidery") {
        commonProperties["Embroidery Size"] = choiceValue("embroidery-size");

        const exactInches = Number(embroiderySizeInput?.value);
        if (Number.isFinite(exactInches) && exactInches > 0) {
          commonProperties["Embroidery Exact Size"] = `${exactInches}"`;
        }
      }

      const formData = new FormData(form);
      formData.set("id", mainVariant.id);
      formData.set("quantity", quantity);

      Object.entries({
        ...commonProperties,
        "_Charge Type": "base_product"
      }).forEach(([key, value]) => {
        if (value) formData.set(`properties[${key}]`, value);
      });

      try {
        let response = await fetch(
          `${window.Shopify?.routes?.root || "/"}cart/add.js`,
          {
            method: "POST",
            body: formData,
            headers: { "Accept": "application/json" }
          }
        );

        if (!response.ok) throw new Error(await response.text());

        const items = [];
        selectedKeys().forEach(key => {
          const def = defs[key];
          if (!def || !def.available) return;

          items.push({
            id: def.id,
            quantity: def.charge === "one_time" ? 1 : quantity,
            properties: {
              "_Configuration ID": configurationId,
              "_Builder Category": "apparel",
              "_Charge Type": def.charge,
              "_Add On": def.title,
              "_Add On SKU": def.sku
            }
          });
        });

        if (items.length) {
          response = await fetch(
            `${window.Shopify?.routes?.root || "/"}cart/add.js`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
              },
              body: JSON.stringify({ items })
            }
          );

          if (!response.ok) throw new Error(await response.text());
        }

        message.textContent = "Added to cart.";
        window.location.href = "/cart";
      } catch (error) {
        console.error(error);
        message.textContent =
          "Could not add this configuration. Confirm the decoration, embroidery, artwork, and finishing add-on products are selected, every SKU matches, and each variant is available on the Online Store channel.";
      }
    });

    refreshConditionalRows();
    selectVariant(chosenVariant());
  });
})();